







































































import Vue from "vue";
import store, { GeneralLedgerStore } from "../services/store";
import ApiSearchPage from "@/components/apiSearch/components/ApiSearchPage.vue";
import { ApiSearchColumn } from "@/components/apiSearch/models/ApiSearch";
import ButtonCheckBox from "@/components/ButtonCheckBox.vue";
import TransactionsDimensions from "../components/TransactionsDimensions.vue";
import { dateFormatHU } from "@/filters/date-format";
import MoneyDisplay from "@/components/MoneyDisplay.vue";
import { t } from "@/plugins/i18n";

interface Data {
  store: GeneralLedgerStore;
}

export default Vue.extend<Data, {}, {}, {}>({
  components: {
    ApiSearchPage,
    ButtonCheckBox,
    TransactionsDimensions,
    MoneyDisplay,
  },

  data: () => ({ store }),

  methods: {
    setDate(date: Date) {
      if (
        new Date(dateFormatHU(date.toString())) >
        new Date(dateFormatHU(new Date("1990-01-01").toString()))
      ) {
        return dateFormatHU(date.toString());
      } else return "-";
    },
  },

  computed: {
    columns: (): ApiSearchColumn[] => [
      {
        field: "isHasDimensions",
        cell: "dimensionsChk",
        filterable: false,
        sortable: false,
      },
      { field: "trans", title: t("TranzakcioAzonosito") },
      {
        field: "accDate",
        title: t("GeneralLedger_GazdEsDatum"),
        cell: "accDate",
      },
      { field: "prefix", title: t("Prefix") },
      { field: "invoiceType", title: t("SzamlaTipusa") },
      { field: "bookType", title: t("Naplo") },
      { field: "productionId", title: t("GeneralLedger_GyartasiLejelentes"), cell: "productionId" },
      { field: "taskCard", title: t("GeneralLedger_Feladatkartya"), cell: "taskCard" },
      {
        field: "bookingDate",
        title: t("GeneralLedger_KonyvekbenTortenoRogzitesPontosIdeje"),
        cell: "bookingDate",
      },
      { field: "accSign", title: t("GeneralLedger_TartozikKovetel"), cell: "accSignTemp" },
      { field: "total", title: t("Osszeg"), cell: "total" },
      { field: "currTotal", title: t("GeneralLedger_OsszegDevizaban"), cell: "currTotal" },
      { field: "balance", title: t("Egyenleg"), cell: "balance" },
      { field: "accNo", title: t("FokSzam") },
      { field: "againstAccno", title: t("GeneralLedger_EllenFokSzam"), filterable: false, sortable: false },
      { field: "accNoName", title: t("GeneralLedger_FokSzamNeve") },
      { field: "invNo", title: t("Szamlaszam") },
      { field: "partner", title: t("PartnerNeve") },
      { field: "note", title: t("Megjegyzes") },
      { field: "remark", title: t("GeneralLedger_EgyebAzon") },
      { field: "bookingUser", title: t("Ellenor"), cell: "bookingUser" },
      { field: "user", title: t("GeneralLedger_LetrehFelh") },
      { field: "currency", title: t("Penznem") },
      { field: "exchangeRate", title: t("Arfolyamszorzo"), cell: "exchangeRate" },
    ],
  },
});
